import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  ticketId: yup.number().required('Carrier is a required field'),
  destinationId: yup.number().required('Destination is a required field'),
  invoiceDate: yup.date().required('Invoice date is a required field'),
  invoiceNumber: yup.string().required('Invoice number is a required field'),
  invoiceAmount: yup.number().required('Invoice amount is a required field'),
  materialId: yup.string().required('Material is a required field'),
  materialDescription: yup.string().nullable().optional(),
  purchaseOrderId: yup.string().nullable().optional(),
  salesInvoice: yup.mixed().required('Invoice is a required file'),
  weightCertificate: yup.mixed().required('Weight cert. is a required file'),
  BL: yup.mixed().required('B/L is a required file'),
  radioactiveCertificate: yup.mixed().required('Radioactive cert. is a required file'),
  photos: yup.mixed().required('This is a required file'),
})

export const validationUpdateSchema = yup.object().shape({
  destinationId: yup.number().required('Destination is required'),
  invoiceDate: yup.date().optional(),
  invoiceNumber: yup.string().optional(),
  invoiceAmount: yup.number().optional(),
  materialId: yup.string().optional(),
  purchaseOrderId: yup.string().nullable().optional(),
  salesInvoice: yup.mixed().optional(),
  weightCertificate: yup.mixed().optional(),
  BL: yup.mixed().optional(),
  radioactiveCertificate: yup.mixed().optional(),
})

export interface FormType {
  ticketId: number
  destinationId: number
  invoiceDate: Date
  invoiceNumber: string
  invoiceAmount: number
  materialId: string
  materialDescription: string
  purchaseOrderId?: string
  salesInvoice: Blob
  weightCertificate: Blob
  BL: Blob
  radioactiveCertificate: Blob
  photos: Blob[]
}

export interface UpdateForm {
  destinationId: number
  invoiceDate: Date
  invoiceNumber: string
  invoiceAmount?: number
  materialId?: string
  materialDescription?: string
  purchaseOrderId?: string
  salesInvoice?: Blob
  weightCertificate?: Blob
  BL?: Blob
  radioactiveCertificate?: Blob
  photos: Blob[]
  truckDocumentationId: number
}
